<template>
  <v-container grid-list-md text-xs-left>
    
    <v-layout row wrap>
      <v-flex xs12 class="display-1 font-weight-light">
          TOOLS AND SERVICES
      </v-flex>

      <v-flex xs12>
          <h1>Rotational Assignment Programs</h1>
      </v-flex>

      <v-flex xs12 sm6>
        <h3>Broaden Your Leadership Perspective</h3>
        <p>Expand your organizational knowledge and managerial skillset by participating in a rotational assignment program or by hosting a high-performing employee. Rotational assignment programs are exciting opportunities for current and emerging leaders at FAA; they offer short- term, meaningful assignments that expand participants’ experience outside of their current area of expertise, strengthen collaboration across the Agency and government, and build the leadership skills necessary to lead at FAA and other Federal agencies. </p>
      </v-flex>

      <v-flex xs12 sm6>
        <h4>Why consider a rotational assignment?</h4>
        <p>Rotational assignment programs support your leadership development by:</p>
        <ul>
          <li>Creating new opportunities to expand your current set of leadership and management skills</li>
          <li>Broadening your organizational experience by tackling complex issues outside of your home line of business/ staff office (LOB/SO)</li>
          <li>Deepening your understanding of the overall Agency and government mission</li>
          <li>Exposing you to different management techniques and leadership styles</li>
          <li>Supporting development of your personal and professional leadership qualities</li>
        </ul>
      </v-flex>

      <v-flex xs12>
          <p></p>
          <v-divider></v-divider>
          <p></p>
          <h1>Rotational Assignment Opportunities</h1>
      </v-flex>

      <v-flex xs12 sm6>
        <h3>U.S. DEPARTMENT OF TRANSPORTATION (DOT) DEPARTMENTAL ROTATIONAL ASSIGNMENT PROGRAM (DRAP)</h3>
        <p>The Departmental Rotational Assignment Program (DRAP) is a competitive opportunity within the U.S. Department of Transportation (DOT) designed to broaden employee experiences in transportation systems and build cross- DOT awareness through short-term rotation assignments. There are two cohorts per year, for a duration of 6 months. Assignments are non-reimbursable.</p>

        <h4>Who Can Apply?</h4>
        <ul>
          <li>January-June cohort: GS 13-15 or equivalent employees</li>
          <li>July-December cohort: GS 12 and below equivalent employees.</li>
        </ul>

        <p></p>

        <h3>FAA ROTATIONAL ASSIGNMENT PROGRAM</h3>
        <p>The FAA Rotational Assignment Program is a competitive opportunity within FAA designed to broaden employee experiences and build cross-FAA awareness through short-term rotation assignments. Assignments are non-reimbursable.</p>
        <h4>Who Can Apply?</h4>
        <p>High-performing FAA employees endorsed by their line of business/staff office (LOB/SO)</p>
        <p><strong>Assignment Length:</strong> Variable</p>

        <p></p>
        
        <h3>PRESIDENT’S MANAGEMENT COUNCIL (PMC) INTERAGENCY ROTATION PROGRAM</h3>
        <p>The <a href="https://my.faa.gov/tools_resources/training_learning/rotationaldevelopment.html">President’s Management Council (PMC) Interagency Rotation Program</a> is hosted by the Office of Personnel Management and enables emerging Federal leaders to expand their management skills, broaden their organizational experience, and build their professional networks by providing them the opportunity to serve in rotational assignments in other Federal agencies. The PMC Interagency Rotation Program also strengthens agencies themselves by encouraging interagency collaboration, facilitating best practice sharing across departments, and building a pipeline of emerging leaders who possess a broad understanding of the varied missions across the Federal government. Assignments are non-reimbursable.</p>
        <p>Specifically, the program aims to:</p>
        <ul>
          <li>Deliver a collaborative, cross-agency program to reduce barriers to interagency mobility</li>
          <li>Enhance PMC participants’ leadership competencies through a meaningful rotational assignment and through other developmental opportunities outside of their current agencies</li>
          <li>Expand PMC participants’ interagency experience either within or outside their current area of expertise</li>
          <li>Offer engaging and insightful interagency cohort events that allow each participant to network and interact with other program participants, Federal employees, and senior executives</li>
        </ul>
        <p></p>
        <h4>Who Can Apply?</h4>
        <p>High-potential and high-performing GS 13-15 or equivalent employees in the National Capital Region</p>
        <p><strong>Assignment Length:</strong> 6 months; two cohorts per year, October-March, and April-September</p>
      </v-flex>

      <v-flex xs12 sm6>
        <h3>FAA EXECUTIVE EXCHANGE PROGRAM: MAKING STRATEGIC CONNECTIONS</h3>
        <p>The FAA Executive Exchange Program offers a unique opportunity for FAA executives to expand their organizational knowledge, build strategic connections, and enhance their leadership skillset in an FAA line of business/staff office (LOB/SO) other than their own.</p>
        <p>Upon completion of their exchange, rotation, or shadowing experiences, executives return to their home organizations ready to drive change, foster innovation, promote FAA Strategic Leadership Capabilities (SLCs), and spur growth that will lead the Agency forward.</p>
        <p></p>
        <h4>Who Can Participate?</h4>
        <p>FAA Executives</p>
        <p><strong>Assignment Length:</strong> 4-6 weeks</p>
        <p><strong>Contact:</strong>  <a href="mailto:9-AHD-FLLI-Student-Services@faa.gov">9-AHD-FLLI-Student-Services@faa.gov</a></p>

        <h3>WHITE HOUSE LEADERSHIP DEVELOPMENT (WHLD) PROGRAM</h3>
        <p>The <a href="https://my.faa.gov/tools_resources/training_learning/rotationaldevelopment/execexchange.html">White House Leadership Development (WHLD) Program</a> is a unique and challenging opportunity for high potential and high-performing GS-15 and equivalent employees who are poised to enter the executive ranks. WHLD Fellows step out of their comfort zone for a full year to drive progress on mission-critical programs and deliver long-term strategic results, bettering both themselves and the Federal government. Assignments are non-reimbursable.
        <p>The program provides an opportunity to:</p>
        <ul>
          <li>Gain exposure to a variety of agencies, including cultures, missions, functional areas, and senior leaders</li>
          <li>Improve your ability to address complex problems across organizational and jurisdictional boundaries</li>
          <li>Leverage newly expanded professional networks to identify best practices and address organizational challenges in future positions</li>
        </ul>
        <p></p>
        <h4>Who Can Apply?</h4>
        <p>High-potential and high-performing GS-15 or equivalent employees in the National Capital Region</p>
        <p><strong>Assignment Length:</strong> 1 year; January-December</p>

      </v-flex>

    </v-layout>
   
  </v-container>
</template>

<script>

  export default {
    data () {
        return {
        image: require('@/assets/ThinkstockPhotos-516589445.jpg')
        }
    }
  }</script>

<style>

</style>
